import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import MeetProfessor from './components/MeetProfessor';
import Research from './components/Research';
import StatsBanner from './components/StatsBanner';
import Publications from './components/Publications';
import Students from './components/Students';
import PatentsBooks from './components/PatentsBooks';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="app">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <MeetProfessor />
        <Research />
        <StatsBanner />
        <Publications />
        <Students />
        <PatentsBooks />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default App;
